/**
 * AG Grid utility functions
 */

// Inject filtered header styles
const style = document.createElement("style");
style.textContent = `
  .ag-header-cell.filtered-header {
    background-color: #95a9e0ff !important;
    transition: background-color 0.3s ease;
  }
`;
if (!document.querySelector('style[data-ag-grid-helpers]')) {
  style.setAttribute('data-ag-grid-helpers', 'true');
  document.head.appendChild(style);
}

/**
 * Returns the appropriate header class based on filter state
 * @param {Object} params - AG Grid header params
 * @returns {string} CSS class name for filtered headers
 */
export const getHeaderClass = (params) => {
  const filterModel = params.api.getFilterModel();
  const field = params.colDef?.field || params.column?.getColId();
  return filterModel[field] ? "filtered-header" : "";
};

// agGridHelper.js
export function clearAllFilters(gridApi) {
  if (gridApi) {
    gridApi.setFilterModel(null);
  }
}

export function clearColumnFilter(gridApi, columnField) {
  if (gridApi && columnField) {
    const filterInstance = gridApi.getFilterInstance(columnField);
    if (filterInstance) {
      filterInstance.setModel(null);
      gridApi.onFilterChanged();
    }
  }
}
